export default __webpack_public_path__ + "static/rennerboldarchitype-webfont-c78e506961ade592f2465d923e73136f.woff";